import axios from "axios";
const url = "https://api.bhavansalumniassociation.org";

export default function apidata(endp, method = "get", body, id = "") {
  let requestUrl = `${url}`;

  if (endp !== "") {
    requestUrl += `/${endp}`;
  }

  if (id !== "") {
    requestUrl += `/${id}`;
  }
  return axios({
    method,
    url: requestUrl,
    data: body,
    headers: { "Content-Type": "application/json" },
  }).catch((error) => {
    return error.response.status;
  });
}
